import { ArticleParagraph1 } from '@cian/ui-kit';
import * as React from 'react';

import { NBSP, LF } from '../../constants/symbols';

export const TYPOGRAPHY = {
  SECTION_TITLE: 'Ответы на вопросы',
};

export const FAQ_DATA_LIST = [
  {
    text: '6% для категории самозанятых. Оплата производится самостоятельно в приложении “Мой налог”.',
  },
  {
    text: 'от 6% для индивидуальных предпринимателей. Оплата производится самостоятельно. Размер налога зависит от системы налогообложения.',
  },
  {
    text: 'от 6% для юридических лиц. Оплата производится самостоятельно. Размер налога зависит от системы налогообложения',
  },
];

export const FAQ_DATA = [
  {
    question: `Кто может подключиться к${NBSP}партнёрской программе?`,
    answer: (
      <ArticleParagraph1 color="white_60" whiteSpace="pre-line">
        К партнёрской программе могут подключиться риелторы в статусе самозанятого или юридические лица (ИП, ООО/АО).
        {LF} Физические лица не могут участвовать в программе.
      </ArticleParagraph1>
    ),
  },
  {
    question: `По${NBSP}каким новостройкам можно${NBSP}получить вознаграждение за сделку?`,
    answer: (
      <ArticleParagraph1 color="white_60" whiteSpace="pre-line">
        Агент из любого региона может получить вознаграждение за сделку с новостройками в Москве и Московской области, в
        Санкт-Петербурге и Ленинградской области, в Екатеринбурге и Свердловской области, в Казани и Республике
        Татарстан, а также в Краснодарском крае, Новосибирской и Ростовской областях.
      </ArticleParagraph1>
    ),
  },
  {
    question: `Сколько я${NBSP}могу заработать?`,
    answer: (
      <ArticleParagraph1 color="white_60" whiteSpace="pre-line">
        Вознаграждение в размере 700 000, 1 000 000 и 3 000 000 рублей можно получить при выборе квартиры в новостройке
        через сервис «Продажа квартиры в Новостройке», при стоимости квартир 14 000 000, 20 000 000 и 60 000 000 рублей
        соответственно, вознаграждения от застройщика 5%.
      </ArticleParagraph1>
    ),
  },
  {
    question: `Облагается${NBSP}ли вознаграждение налогом?`,
    answer: (
      <>
        <ArticleParagraph1 color="white_60" whiteSpace="pre-line">
          С полученного вознаграждения необходимо уплатить федеральный налог на доход.
        </ArticleParagraph1>
        <ul>
          {FAQ_DATA_LIST.map(({ text }, index) => (
            <li key={index}>
              <ArticleParagraph1 color="white_60" whiteSpace="pre-line">
                {text}
              </ArticleParagraph1>
            </li>
          ))}
        </ul>
      </>
    ),
  },
] as const;
